const copilot64 = {
    svg: '<svg style="width:4.00rem; height:4.00rem;" viewBox="0 0 200 200"><rect width="100" height="200"/></svg>',
};

export { copilot64 as default };
